module.exports = __webpack_public_path__ + "img/arrow_up.6f0566c7.svg";